export default {
  userObject: state => {
    return state.config.userObject;
  },
  customComponentsConfig: state => currentPageName => {
    return state.config.customComponentsConfig[currentPageName];
  },

  appSlug: state => {
    return state.config.customDashboardConfig.appSlug;
  }
};
